import { useEffect, useRef, useState } from "react";

const TruncatedText = ({ text, maxLines, setAnuncioModal, anuncio }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const textRef = useRef(null);

  useEffect(() => {
    const textElement = textRef.current;

    if (textElement) {
      const lineHeight = parseInt(
        window.getComputedStyle(textElement).lineHeight,
        10
      );
      const elementHeight = textElement.clientHeight;

      const calculatedLineCount = Math.floor(elementHeight / lineHeight);
      setShowButton(calculatedLineCount > maxLines);
      setIsTruncated(true)
    }
  }, [text]);

 

  const textStyles = {
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
    WebkitLineClamp: isTruncated ? maxLines : "unset",
    marginBottom: "0.5rem",
  };

  const openModal = () => {
    setAnuncioModal({ active: true, anuncio: anuncio });
  };

  return (
    <div>
    
      <div className=" pb-2 z-20">
        <p
          className="text-xs  text-justify text-slate-600 whitespace-pre-line"
          style={textStyles}
          ref={textRef}
        >
          {text}
        </p>
      </div>

      {showButton && (
        <div className=" z-50">
          <button
            onClick={openModal}
            className="text-orange-500 text-xs hover:underline z-50 cursor-pointer"
          >
            {"Leer mas"}
          </button>
        </div>
      )}
    </div>
  );
};

export default TruncatedText;
